program CSYDashboard;

uses
  Vcl.Forms,
  WEBLib.Forms,
  SMX.Web.Layout.Utils in '..\..\SMXI-LIBS-2025\Web-Core-Utils\SMX.Web.Layout.Utils.pas',
  SMX.Web.Document.Utils in '..\..\SMXI-LIBS-2025\Web-Core-Utils\SMX.Web.Document.Utils.pas',
  App.Types in '..\XData-Core\Web-Core\App.Types.pas',
  App.Config in '..\XData-Core\Web-Core\App.Config.pas',
  smx.webcore.types in '..\XData-Core\Web-Core\smx.webcore.types.pas',
  WebForm.Core in '..\XData-Core\Web-Core\WebForm.Core.pas'{*.html},
  MainDataModule in 'MainDataModule.pas',
  SMX.Shared in '..\Shared\SMX.Shared.pas',
  SMX.Web.Utils in '..\..\SMXI-LIBS-2025\Web-Core-Utils\SMX.Web.Utils.pas',
  SMX.Web.Service.Consts in '..\XData-Core\Web-Core\SMX.Web.Service.Consts.pas',
  SharedDataModule in 'SharedDataModule.pas',
  MainForm in 'MainForm.pas'{*.html},
  Auth.Service in 'Auth.Service.pas',
  SimpleDashboard in 'SimpleDashboard.pas',
  Simple.Dashboard.Return.Types in '..\Shared\Simple.Dashboard.Return.Types.pas',
  Simple.Dashboard.Bulk.Types in '..\Shared\Simple.Dashboard.Bulk.Types.pas',
  sys.Return.Types in '..\Shared\sys.Return.Types.pas',
  SMX.Auth.Shared in '..\XData-Core\Auth-Shared\SMX.Auth.Shared.pas',
  UserManager in 'Admin\UserManager.pas'{*.html},
  SMX.Web.Table.Simple in '..\..\SMXI-LIBS-2025\Web-Core-Utils\SMX.Web.Table.Simple.pas',
  UserEdit in 'Admin\UserEdit.pas'{*.html},
  UserManager.Utils in 'Admin\UserManager.Utils.pas',
  SMX.ReturnTypes in '..\XData-Core\Services\SMX.ReturnTypes.pas',
  DashboardForm in 'DashboardForm.pas'{*.html},
  CSY.Enumerations in '..\Shared\Entities\CSY.Enumerations.pas',
  BranchGroupManager in 'Admin\BranchGroupManager.pas'{*.html},
  SMX.XData.Utils in '..\XData-Core\Web-Core\SMX.XData.Utils.pas',
  DashboardItemFactory in 'DashboardItemFactory.pas',
  DashboardParamsBuilder in 'DashboardParamsBuilder.pas',
  BaseDashboardItem in 'BaseDashboardItem.pas',
  DashboardItemLayout in 'DashboardItemLayout.pas',
  DashboardItemWidget in 'DashboardItemWidget.pas',
  Configuration in 'Configuration.pas'{*.html},
  UserDashboardConfiguration in 'UserDashboardConfiguration.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TMainData, MainData);
  Application.Run;
end.
